import { render, staticRenderFns } from "./PerformanceRoadshow.vue?vue&type=template&id=6be727b2&scoped=true"
import script from "./PerformanceRoadshow.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformanceRoadshow.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PerformanceRoadshow.vue?vue&type=style&index=0&id=6be727b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be727b2",
  null
  
)

export default component.exports